import { useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "../../components/ui/switch";
import { api, pct, dt } from "../../lib/api";
import { useLoad, act, Card, Badge, Sim, H1, Table, abtn, ainput } from "../../components/admin/ui";

export default function Suppliers() {
  const [sups, reload] = useLoad("/admin/suppliers");
  const [filter, setFilter] = useState("");
  const [inv, reloadInv] = useLoad("/admin/inventory", { filter });
  const [ints] = useLoad("/admin/integrations");
  const toggle = async (s) => {
    const r = await act(() => api.post(`/admin/suppliers/${s.id}/toggle`, { enabled: !s.enabled }));
    if (r) act(async () => null, `${r.affected_products} produit(s) affecté(s) · ${r.alternative_products} alternative(s) trouvée(s)`);
    reload(); reloadInv();
  };
  const sync = async () => { const r = await act(() => api.post("/admin/suppliers/sync")); if (r) act(async () => null, `${r.checked} vérifiés · ${r.changes} changements · ${r.failures} échecs`); reload(); reloadInv(); };
  return (
    <div>
      <H1 sub="Architecture de fournisseurs interchangeables (SupplierAdapter). Temu Canada fonctionne en mode manuel : aucune commande n'est passée automatiquement sans API officiellement autorisée.">Fournisseurs & intégrations</H1>
      <Card title="État des intégrations" testid="integrations-status" className="mb-6">
        {(ints || []).map((i) => <div key={i.name} className="flex justify-between gap-4 py-2 border-b border-[#1E222D] text-sm"><span>{i.name}<span className="block text-xs text-slate-500">{i.detail}</span></span><Badge v={i.status} /></div>)}
      </Card>
      <div className="grid lg:grid-cols-3 gap-4 mb-8">
        {(sups || []).map((s) => (
          <Card key={s.id} testid={`supplier-card-${s.id}`} title={<span className="flex gap-2 items-center">{s.code} {s.mode === "manual" ? <Badge v="manuel" /> : <Sim />}</span>} right={<Switch data-testid={`supplier-toggle-${s.id}`} checked={s.enabled} onCheckedChange={() => toggle(s)} />}>
            <div className="text-base mb-3">{s.name}</div>
            <div className="grid grid-cols-2 gap-2 text-xs font-mono">
              <div>Fiabilité <span className="text-emerald-400">{pct(s.reliability, 0)}</span></div><div>Taux d'échec <span className="text-amber-400">{pct(s.failure_rate)}</span></div>
              <div>Fraîcheur max {s.freshness_minutes} min</div><div>Retours {s.return_policy.window_days} j</div>
              <div>Produits {s.products}</div><div>Publiés {s.published}</div>
              <div>Commandes {s.orders_count}</div><div className={s.sync_errors ? "text-red-400" : ""}>Erreurs synchro {s.sync_errors}</div>
            </div>
            <div className="text-[11px] text-slate-500 mt-3">Dernière synchro {dt(s.last_sync_at)} · origine {s.origin}</div>
          </Card>
        ))}
      </div>
      <Card title="Inventaire centralisé" right={
        <div className="flex gap-2">
          <select data-testid="inventory-filter" value={filter} onChange={(e) => setFilter(e.target.value)} className={ainput}>
            <option value="">tous</option><option value="low">stock faible</option><option value="out">rupture</option><option value="stale">données périmées</option>
          </select>
          <button data-testid="supplier-sync-button" onClick={sync} className={abtn}>Synchroniser maintenant</button>
        </div>}>
        <Table testid="inventory-table" rows={inv || []} cols={[
          ["Produit", (p) => <Link to={`/admin/products/${p.id}`} className="hover:text-emerald-300">{p.title}</Link>],
          ["Statut", (p) => <Badge v={p.status} />], ["Stock", (p) => <span className="font-mono">{p.total_stock}</span>], ["Réservé", (p) => <span className="font-mono">{p.reserved}</span>],
          ["État", (p) => <Badge v={p.state} />], ["Fraîcheur", (p) => <span className={p.fresh ? "text-emerald-400 text-xs" : "text-red-400 text-xs"}>{p.fresh ? "à jour" : "périmé"} · {dt(p.last_sync_at)}</span>],
          ["Note", (p) => <span className="text-xs text-slate-500">{p.suspend_reason || p.sync_error || ""}</span>],
        ]} />
      </Card>
    </div>
  );
}
